import React, { FC } from "react"
import { Path, Svg, View } from "@react-pdf/renderer"

export type PdfIcon = {
    fill: string
}
const AccessTime: FC<PdfIcon> = (props) => {
    const { fill } = props;
    return (
        <View style={{height: 22, width: 20}}>
            <Svg height={30} width={30}>
                <Path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8" 
                    fill={fill || "currentColor"} // Set fill from props or default to 'currentColor'
                />
                <Path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" 
                    fill={fill || "currentColor"} // Set fill from props or default to 'currentColor'
                />
            </Svg>
        </View>
    )
}

export default AccessTime;